import useSWR from "swr";
import OrderEmailLogService from "services/OrderEmailLogService";

const fetchOrderEmailLog = async (params) => {
    const response = await OrderEmailLogService.get(params);
    return response.data;
};

const useOrderEmailLog = (params) => {
    const { data, error, mutate, isValidating } = useSWR(
        params?.orderId || params?.id ? [`order-email-log`, params] : null,
        () => fetchOrderEmailLog(params),
        {
            revalidateOnFocus: false,
            shouldRetryOnError: false
        }
    );

    return {
        emailLog: data?.data,
        loading: (!data && !error) || isValidating,
        error,
        refetch: mutate,
    };
};

export default useOrderEmailLog;
